export class BancosModel {
  id_banco: number;
  nome: string;
  favorecido: string;
  agencia: string;
  conta: string;
  documento: string;
}



// WEBPACK FOOTER //
// ./src/app/bancos/bancos.model.ts